import { Fragment } from "react";
import { Button } from "../../../../core/components/atoms/Button";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";
import { essayTitle } from "../../utils";

interface IModalHowToChange {
  correction: number;
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalHowTo({ correction, isOpen, onClose }: IModalHowToChange) {

  const howToText = () => {
    if(correction === 3) {
      return (
        <Typography>
          Os critérios possuem pesos 3, 2, 3, 2, respectivamente, obtendo-se, assim, uma nota final de redação, que variará entre 10 e 50 pontos.
        </Typography>
      ) 
    }

    return (
      <Fragment>
        <Typography>
          A nota máxima possível na redação Unesp é 28. Para chegar a este número, é realizado o seguinte cálculo, 
          de acordo com os critérios descritos acima:
          <br /> NF = (NC*NE)/NMC
          <br /> NF: Nota Final
          <br /> NC:Nota atribuída pela correção Vunesp (escala de 0 a 11)
          <br /> NE: Nota máxima prevista em edital (28 - Unesp)
          <br /> NMC: Nota máxima prevista pela correção Vunesp (11 pontos)
        </Typography>
      </Fragment>
    )
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position="center"
      className="p-0 w-2/6"
    >
      <div className="flex flex-col gap-xl">
        <Typography weight="bold">
          Como a nota do {essayTitle(correction)} é calculada?
        </Typography>
        {howToText()}
        <div className="flex f1lex-row items-center justify-end gap-sm">
          <Button variant="text" onClick={() => onClose()}>
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  )
}